import axios from "axios";
import { config } from "../config";

export class RolesService {
  /*********** List ***********/
  public list = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "roles");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };

  public listCategories = async (): Promise<any> => {
    try {
      const { serverUrl } = config;
      const response = await axios.get(serverUrl + "categories");
      return response.data;
    } catch (error) {
      return { message: "error" };
    }
  };
}
